// extracted by mini-css-extract-plugin
export default {"InputVerify":"Verify_InputVerify__lBbJK","Phone":"Verify_Phone__puuds","ContactSecretary":"Verify_ContactSecretary__73b13"};